"use client"

import { useEffect } from "react"
import { FasHero } from "@/features/client/sections/Fas/FasHero"
import { FasGallery } from "@/features/client/sections/Fas/Gallery"
import { FasCoreValues } from "@/features/client/sections/Fas/CoreValues"
import { FasApproach } from "@/features/client/sections/Fas/Approach"
import { FasPurpose } from "@/features/client/sections/Fas/Purpose"
import { FasCallToAction } from "@/features/client/sections/Fas/CallToAction"

// Extend Window interface for Facebook SDK
declare global {
  interface Window {
    FB?: {
      XFBML: {
        parse: (element?: HTMLElement) => void
      }
      init: (params: {
        appId?: string
        xfbml: boolean
        version: string
      }) => void
    }
    fbAsyncInit?: () => void
  }
}

const Fas = () => {
  // Initialize Facebook SDK for Page Plugin
  useEffect(() => {
    // Check if SDK is already loaded
    if (window.FB) {
      window.FB.XFBML.parse()
      return
    }

    // Define the callback for when SDK loads
    window.fbAsyncInit = () => {
      window.FB?.init({
        xfbml: true,
        version: "v18.0",
      })
    }

    // Load the SDK asynchronously
    if (!document.getElementById("facebook-jssdk")) {
      const script = document.createElement("script")
      script.id = "facebook-jssdk"
      script.src = "https://connect.facebook.net/en_US/sdk.js"
      script.async = true
      script.defer = true
      script.crossOrigin = "anonymous"
      document.body.appendChild(script)
    }
  }, [])

  return (
    <main className="min-h-screen bg-white">
      <FasHero />
      <FasGallery />
      <FasCoreValues />
      <FasApproach />
      <FasPurpose />
      <FasCallToAction />
    </main>
  )
}

export default Fas
